<template>
  <v-app>
    <core-app-bar />

    <core-drawer />

    <core-members-view :userStatuses="userStatuses" :isReviewAction="isReviewAction"  />

    <core-footer />

  </v-app>
</template>

<script>
export default {
  name: 'ReviewMembers',

  components: {
    CoreAppBar: () => import('../components/core/AppBar'),
    CoreDrawer: () => import('../components/core/Drawer'),
    CoreMembersView: () => import('../components/core/MembersView'),
    CoreFooter: () => import('../components/core/Footer'),
  },

  data: () => ({
    expandOnHover: false,
    isReviewAction: true,
    userStatuses: [
        'NEW',
        'ADMIN_REVIEW'
    ]
  }),
}
</script>
